export const styleAppCell = (name) => {
  switch (name) {
    case 'Gecond':
      return 'app--gecond';
    case 'Gimob':
      return 'app--gimob';
    case 'Gesar':
      return 'app--gesar';
    default:
      return 'app--comum';
  }
};
